export const KIOSK_PAYMENT_TYPES = {
  creditCard: "creditCard",
  mobileWallet: "mobileWallet",
  ticketTender: "loaded_ticket"
}

export const PAYMENT_TYPES = {
  CREDIT_CARD: 'freedompay_credit',
  CASH: 'cash',
  QR_PAY: 'wallet_nonce',
  TICKET: 'loaded_ticket',
  GIFT_CARD: 'gift_card',
  VN_API_QR_PAY: 'vnapi_qrpay',
  VN_API_TICKET: 'vnapi_ticket',
  VN_API_GIFT_CARD: 'vnapi_giftcard',
}
